import { uniqBy, sortBy } from 'lodash-es'
import { KnownWord, word2vec, WordTable } from './wordtable'

// ------

function findTransposedWordsInTable (wordTable: WordTable, word: string): KnownWord[] {
  const vec = word2vec(word)
  const hash = vec.join('/')
  const bucket = wordTable.get(hash)
  return (bucket != null) ? bucket : []
}

export interface Mnemonic {
  mnemonic: KnownWord
  permutation: number[]
}

export function findMnemonics (wordTable: WordTable, queryChunked: string[]): Mnemonic[] {
  if (queryChunked.length <= 1) return []

  const candidates: Mnemonic[] = []

  const vi = new Array(queryChunked.length).fill(0)
  for (;;) {
    const chArr = []
    for (let i = 0; i < queryChunked.length; i++) {
      chArr.push(queryChunked[i]![vi[i]])
    }

    const tableQuery = chArr.join('')
    const knownWords = findTransposedWordsInTable(wordTable, tableQuery)
    if (knownWords.length > 0) {
      for (const w of knownWords) {
        candidates.push({
          mnemonic: w,
          permutation: calculateStringPermutationMapper(tableQuery, w.correspondingLatin)
        })
      }
    }

    let cursor = 0
    while (cursor < queryChunked.length) {
      vi[cursor]++
      if (vi[cursor] < queryChunked[cursor]!.length) break
      else vi[cursor++] = 0
    }
    if (cursor === queryChunked.length) break
  }

  const uniques = uniqBy(candidates, (c) => c.mnemonic.display)
  return sortBy(uniques, u => u.mnemonic.display)
}

/// /

function calculateStringPermutationMapper (from: string, to: string): number[] {
  const chLastIdx = new Map<string, number>()
  const permutation = [] as number[]
  for (let i = 0; i < from.length; i++) {
    const ch = from[i]!!
    let currentIndex = -1
    for (let j = (chLastIdx.get(ch) ?? -1) + 1; j < to.length; j++) {
      if (to[j]!! === ch) {
        currentIndex = j
        chLastIdx.set(ch, j)
        break
      }
    }
    permutation.push(currentIndex)
  }
  return permutation
}
